import { CreateOrUpdateEscrowSettingsApiRow, CreateOrUpdateEscrowSettingsRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

// Update uses the same row shape as create — the processor branches on whether
// a matching active escrow setting exists, not on the row shape.
export const validateUpdateEscrowSettings = makeValidator({
  FieldParser: CreateOrUpdateEscrowSettingsRow,
});

export const validateUpdateEscrowSettingsApi = makeValidator({
  FieldParser: CreateOrUpdateEscrowSettingsApiRow,
});
